import React, { Component } from 'react';
import Content from './components/content';
import Footer from './components/footer';
import NavMenu from './components/nav-menu';
import SelfPortrait from './components/self-portrait';

import './styles/app.scss';

class Jacefarm extends Component {

  render() {
    return (
      <div className="jacefarm">
        <NavMenu />
        <SelfPortrait />
        <Content />
        <Footer />
      </div>
    )
  }
}

export default Jacefarm;
